module.exports = __webpack_public_path__ + "img/00002.40d64948.webp";